import { associatePerformanceService, accountAssociateHierarchyService } from 'config/api';
import actionTypes from './actionTypes';
import { adjustPerformanceParams } from '../utils';

export const getTransactionDetailsV2 =
  (associatePin, options = {}, version = 'v3') =>
  async (dispatch) => {
    dispatch({
      type: actionTypes.TRANSACTION_DETAILS_V2_LOADING,
    });

    const params = adjustPerformanceParams(options);

    const endpointUrl = `/${version}/data/${associatePin}/associateOrderItemsV2`;

    try {
      const {
        data: { items, count },
      } = await associatePerformanceService.post(endpointUrl, params);

      dispatch({ type: actionTypes.TRANSACTION_DETAILS_V2_SUCCESS, payload: { items, count } });
    } catch (error) {
      dispatch({ type: actionTypes.TRANSACTION_DETAILS_V2_ERROR, payload: error });
    }
  };

export const getAssociateClientDetails =
  (associatePin, options = {}, isPerfChannelsEnabled = false) =>
  async (dispatch) => {
    dispatch({
      type: actionTypes.PERF_CLIENT_DETAILS_LOADING,
    });

    const params = adjustPerformanceParams(options);

    if (!isPerfChannelsEnabled) delete params.filter.channels;

    try {
      const { data } = await associatePerformanceService.post(
        `/v1/associate/${associatePin}/sales/metrics/clients`,
        params,
      );

      dispatch({ type: actionTypes.PERF_CLIENT_DETAILS_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: actionTypes.PERF_CLIENT_DETAILS_ERROR, payload: error });
    }
  };

export const getAssociateDetails = (associatePin) => async (dispatch) => {
  dispatch({
    type: actionTypes.PERF_ASSOCIATE_DATA_LOADING,
  });

  try {
    const { data } = await accountAssociateHierarchyService.get(`/associateInfo/${associatePin}`);
    dispatch({ type: actionTypes.PERF_ASSOCIATE_DATA_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: actionTypes.PERF_ASSOCIATE_DATA_ERROR, payload: error });
  }
};

export const resetAssociateClientDetails = () => ({
  type: actionTypes.PERF_RESET_CLIENT_DETAILS,
});

export const resetAssociateSales = (keepLoadingState = false) => ({
  type: actionTypes.RESET_ASSOCIATE_SALES,
  payload: { keepLoadingState },
});

export const resetAssociateDetails = (keepLoadingState = false) => ({
  type: actionTypes.PERF_RESET_ASSOCIATE_DATA,
  payload: { keepLoadingState },
});
